import * as React from 'react'
import { memo, useMemo } from 'react'

import { CommunityIcon } from '@/components/atoms/Logo/CommunityIcon'
import { Avatar, AvatarProps } from '@/components/ui/avatar'
import { useColorModeValue } from '@/components/ui/color-mode'
import { NetworkLogoFragment } from '@/graphql/api/generated'

type Props = {
  network: NetworkLogoFragment
  alt?: string
  /** When set (e.g. wizard draft data URL), overrides the network's own mark. */
  previewSrc?: string | null
} & AvatarProps

export const NetworkLogo = memo(
  ({ network, previewSrc, ...otherProps }: Props) => {
    const borderColor = useColorModeValue('#eee', '#444')
    const bgColor = useColorModeValue('white', 'gray.700')

    const logoUrl = useMemo(() => {
      if (previewSrc) {
        return previewSrc
      }
      return network.squareIcon?.contentUrl
    }, [previewSrc, network.squareIcon?.contentUrl])

    const icon = useMemo(() => <CommunityIcon width={30} height={30} />, [])

    return (
      <Avatar
        src={logoUrl}
        icon={icon}
        border={`1px solid ${borderColor}`}
        boxShadow="lg"
        bg={bgColor}
        name={network.name}
        title={network.name}
        {...otherProps}
      />
    )
  }
)
